import { defineMessages } from 'react-intl'

export default defineMessages({
  eventEmpty: {
    id: 'containers.SupplierActivity.eventEmpty',
    defaultMessage: 'Event is empty!',
  },
  submit: {
    id: 'containers.SupplierActivity.submit',
    defaultMessage: 'Submit',
  },
  addActivity: {
    id: 'containers.SupplierActivity.addActivity',
    defaultMessage: 'Add an activity entry for {name}',
  },
})
